import { RelationalOperator } from '@lambda-layer/types/filter';

/**
 * Maps RelationalOperator enum values to compact display strings for the UI
 */
export const getOperatorDisplayLabel = (
  operator: RelationalOperator
): string => {
  switch (operator) {
    case RelationalOperator.EQUAL:
      return '=';
    case RelationalOperator.NOT_EQUAL:
      return '≠';
    case RelationalOperator.GREATER_THAN:
      return '>';
    case RelationalOperator.GREATER_THAN_OR_EQUAL:
      return '≥';
    case RelationalOperator.LESS_THAN:
      return '<';
    case RelationalOperator.LESS_THAN_OR_EQUAL:
      return '≤';
    case RelationalOperator.NOT_IN:
      return '∉';
    // Array operators with compact symbols
    case RelationalOperator.CONTAINS_ANY:
      return '∈'; // "element of" - contains any
    case RelationalOperator.CONTAINS_NONE:
      return '∉'; // "not element of" - contains none
    case RelationalOperator.CONTAINS_ALL:
      return '⊇'; // "superset or equal" - contains all
    default:
      return operator; // Fallback to the original enum value
  }
};

/**
 * Maps RelationalOperator enum values to descriptive tooltips for better UX
 */
export const getOperatorTooltip = (operator: RelationalOperator): string => {
  switch (operator) {
    case RelationalOperator.EQUAL:
      return 'Equal to';
    case RelationalOperator.NOT_EQUAL:
      return 'Not equal to';
    case RelationalOperator.GREATER_THAN:
      return 'Greater than';
    case RelationalOperator.GREATER_THAN_OR_EQUAL:
      return 'Greater than or equal to';
    case RelationalOperator.LESS_THAN:
      return 'Less than';
    case RelationalOperator.LESS_THAN_OR_EQUAL:
      return 'Less than or equal to';
    case RelationalOperator.NOT_IN:
      return 'Not in';
    // Array operators with clear descriptions
    case RelationalOperator.CONTAINS_ANY:
      return 'Contains any of the selected values';
    case RelationalOperator.CONTAINS_NONE:
      return 'Contains none of the selected values';
    case RelationalOperator.CONTAINS_ALL:
      return 'Contains all of the selected values';
    default:
      return operator;
  }
};
